// extracted by mini-css-extract-plugin
export default {"item":"TaskList_item__+-51B","title":"TaskList_title__f+qMF","status":"TaskList_status__QK5Gl","date":"TaskList_date__D16re"};